import AUTO from "../../assets/images/insurance/AUTO.jpg";
import ACCIDENTES from "../../assets/images/insurance/ACCIDENTES.jpg";
import HOGAR from "../../assets/images/insurance/HOGAR.jpg";
import SALUD from "../../assets/images/insurance/SALUD.jpg";
import TRACTOCAMIONES from "../../assets/images/insurance/TRACTOCAMIONES.jpg";
import EMPRESARIAL from "../../assets/images/insurance/EMPRESARIAL.jpg";
import VIDA from "../../assets/images/insurance/VIDA.jpg";
import VIDA_GRUPO from "../../assets/images/insurance/VIDA_GRUPO.jpg";

export const SERVER_URL = "https://bts_services.bajatuseguro.com/";
export const APP_ID = "APP_ID=APP_M_WEB_04";
export const REGEX = {
	email:
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}\])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/,
	phone: /^\+?([\d]{2})\)?[-. ]?([\d]{4})[-. ]?([\d]{4})$/,
	text: /^[\w'\-,.][^0-9_!¡÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{1,}$/,
	number: /^[\d]+$/,
};
export const InsuranceList = {
	persons: [
		{
			id: 1,
			key: "automovil",
			path: "/automovil",
			title: "Automóvil",
			img: AUTO,
		},
		{
			id: 2,
			key: "accident",
			path: "/accident",
			title: "Accidentes personales",
			img: ACCIDENTES,
		},

		{
			id: 3,
			key: "hogar",
			path: "/hogar",
			title: "Hogar",
			img: HOGAR,
		},
		{
			id: 4,
			key: "vida",
			path: "/vida",
			title: "Vida",
			img: VIDA,
		},
		{
			id: 5,
			key: "medical-expense",
			path: "/medical-expense",
			title: "Gastos médicos",
			img: SALUD,
		},
		// {
		// 	id: 6,
		// 	key: "responsabilidad",
		// 	path: "/responsabilidad",
		// 	title: "Responsabilidad Civil",
		// 	img: RESPONSABILIDAD,
		// },
	],
	company: [
		{
			id: 1,
			key: "automovil",
			path: "/company/automovil",
			title: "Auto/Flotilla",
			img: AUTO,
		},
		{
			id: 2,
			key: "accident",
			path: "/company/accident",
			title: "Accidentes personales",
			img: ACCIDENTES,
		},
		{
			id: 3,
			key: "tractocamiones",
			path: "/company/tractocamiones",
			title: "Tractocamiones",
			img: TRACTOCAMIONES,
		},
		{
			id: 4,
			key: "vida-grupo",
			path: "/company/vida-grupo",
			title: "Vida Grupo",
			img: VIDA_GRUPO,
		},
		{
			id: 5,
			key: "medical-expense-group",
			path: "/company/medical-expense-group",
			title: "Gastos médicos grupal",
			img: SALUD,
		},

		// {
		// 	id: 6,
		// 	key: "responsabilidad",
		// 	path: "/company/responsabilidad",
		// 	title: "Responsabilidad Civil",
		// 	img: RESPONSABILIDAD,
		// },
		{
			id: 6,
			key: "empresarial",
			path: "/company/empresarial",
			title: "Seguro empresarial",
			img: EMPRESARIAL,
		},
	],
};

export const Estado_List = [
	"Aguascalientes",
	"Baja California",
	"Baja California Sur",
	"Campeche ",
	"Chiapas ",
	"Chihuahua",
	"Ciudad de México",
	"Coahuila ",
	"Colima ",
	"Durango ",
	"Estado de México",
	"Guanajuato ",
	"Guerrero ",
	"Hidalgo ",
	"Jalisco",
	"Michoacán ",
	"Morelos ",
	"Nayarit ",
	"Nuevo León ",
	"Oaxaca ",
	"Puebla ",
	"Querétaro ",
	"Quintana Roo ",
	"San Luis Potosí",
	"Sinaloa ",
	"Sonora ",
	"Tabasco ",
	"Tamaulipas ",
	"Tlaxcala ",
	"Veracruz ",
	"Yucatán ",
	"Zacatecas",
];
export const Country_Code = [
	{ name: "Ciudad de México", code: 55 },
	{ name: "Guadalajara", code: 33 },
	{ name: "Monterrey", code: 81 },
	{ name: "Aguascalientes", code: 449 },
	{ name: "Celaya", code: 461 },
	{ name: "Ciudad del Carmen", code: 938 },
	{ name: "Ciudad Victoria", code: 834 },
	{ name: "Cozumel", code: 987 },
	{ name: "Durango", code: 618 },
	{ name: "Guanajuato", code: 473 },
	{ name: "Irapuato", code: 462 },
	{ name: "León", code: 477 },
	{ name: "Matamoros", code: 868 },
	{ name: "Poza Rica", code: 782 },
	{ name: "Puebla", code: 222 },
	{ name: "Querétaro", code: 442 },
	{ name: "Reynosa", code: 899 },
	{ name: "Salamanca", code: 464 },
	{ name: "Saltillo", code: 844 },
	{ name: "San Luis Potosí", code: 444 },
	{ name: "Silao", code: 472 },
	{ name: "Tampico", code: 833 },
	{ name: "Tepíc", code: 311 },
	{ name: "Tizayuca", code: 779 },
	{ name: "Toluca", code: 722 },
	{ name: "Torreón", code: 871 },
	{ name: "Veracruz", code: 229 },
	{ name: "Acaponeta", code: 325 },
	{ name: "Agua Prieta", code: 633 },
	{ name: "Amecameca", code: 597 },
	{ name: "Arcelia", code: 732 },
	{ name: "Autlán", code: 317 },
	{ name: "Bahia de Huatulco", code: 958 },
	{ name: "Cabo San Lucas", code: 624 },
	{ name: "Cadereyta", code: 828 },
	{ name: "Campeche", code: 981 },
	{ name: "Cananea", code: 645 },
	{ name: "Cancún", code: 998 },
	{ name: "Chetumal", code: 983 },
	{ name: "Chihuahua", code: 614 },
	{ name: "Chilapa", code: 756 },
	{ name: "Chilpancingo", code: 747 },
	{ name: "Ciudad Acuña", code: 877 },
	{ name: "Ciudad Camargo", code: 648 },
	{ name: "Ciudad Constitución", code: 613 },
	{ name: "Ciudad Delicias", code: 639 },
	{ name: "Ciudad Guzmán", code: 341 },
	{ name: "Ciudad Hidalgo", code: 786 },
	{ name: "Ciudad Juárez", code: 656 },
	{ name: "Ciudad Mante", code: 831 },
	{ name: "Ciudad Sahagún", code: 791 },
	{ name: "Colima", code: 312 },
	{ name: "Córdoba", code: 271 },
	{ name: "Cuautla", code: 735 },
	{ name: "Cuernavaca", code: 777 },
	{ name: "Cuidad Valles", code: 481 },
	{ name: "Encarnación de Díaz", code: 475 },
	{ name: "Ensenada", code: 646 },
	{ name: "Estancia de los López", code: 324 },
	{ name: "Guadalupe Victoria", code: 676 },
	{ name: "Guaymas", code: 622 },
	{ name: "Hermosillo", code: 662 },
	{ name: "Huetamo", code: 435 },
	{ name: "Huimanguillo", code: 917 },
	{ name: "Huitzuco", code: 727 },
	{ name: "Iguala", code: 733 },
	{ name: "Ixtapan", code: 721 },
	{ name: "Jalapa", code: 228 },
	{ name: "Jalpa", code: 463 },
	{ name: "Jerez de García Salinas", code: 494 },
	{ name: "Jojutla", code: 734 },
	{ name: "Juchitán", code: 971 },
	{ name: "La Barca", code: 393 },
	{ name: "La Paz", code: 612 },
	{ name: "La Piedad", code: 352 },
	{ name: "Lagos De Moreno", code: 474 },
	{ name: "Lerdo De Tejada", code: 284 },
	{ name: "Lerma", code: 728 },
	{ name: "Los Reyes", code: 354 },
	{ name: "Magdalena", code: 632 },
	{ name: "Martínez de la Torre", code: 232 },
	{ name: "Mazatlán", code: 669 },
	{ name: "Mérida", code: 999 },
	{ name: "Mexicali", code: 686 },
	{ name: "Minatitlán", code: 922 },
	{ name: "Mochitlán", code: 754 },
	{ name: "Montemorelos", code: 826 },
	{ name: "Morelia", code: 443 },
	{ name: "Navojoa", code: 642 },
	{ name: "Nogales", code: 631 },
	{ name: "Nuevo Laredo", code: 867 },
	{ name: "Ocotlán", code: 392 },
	{ name: "Ojinaga", code: 626 },
	{ name: "Orizaba", code: 272 },
	{ name: "Pachuca", code: 771 },
	{ name: "Parras de La fuente", code: 842 },
	{ name: "Pénjamo", code: 469 },
	{ name: "Petatlán", code: 758 },
	{ name: "Piedras Negras", code: 878 },
	{ name: "Puerto Peñasco", code: 638 },
	{ name: "Puerto Vallarta", code: 322 },
	{ name: "Puruandiro", code: 438 },
	{ name: "Río Verde", code: 487 },
	{ name: "Rosarito", code: 661 },
	{ name: "Sabinas", code: 861 },
	{ name: "Sahuayo", code: 353 },
	{ name: "Salvatierra", code: 466 },
	{ name: "San Cristóbal de las Casas", code: 967 },
	{ name: "San Fernando", code: 841 },
	{ name: "San José de Gracia", code: 381 },
	{ name: "San Juan del Río", code: 427 },
	{ name: "San Miguel de Allende", code: 415 },
	{ name: "Santa Rosalía", code: 891 },
	{ name: "Santiago Tianguistenco", code: 713 },
	{ name: "Tala", code: 384 },
	{ name: "Tanhuato", code: 356 },
	{ name: "Taxco", code: 762 },
	{ name: "Tecuala", code: 389 },
	{ name: "Tehuacán", code: 238 },
	{ name: "Teloloapan", code: 736 },
	{ name: "Tenancingo", code: 714 },
	{ name: "Tequila", code: 374 },
	{ name: "Texcoco", code: 595 },
	{ name: "Teziutlan", code: 231 },
	{ name: "Tijuana", code: 664 },
	{ name: "Tlapa De Comonfort", code: 757 },
	{ name: "Tlaxcala", code: 246 },
	{ name: "Tula", code: 773 },
	{ name: "Tulancingo", code: 775 },
	{ name: "Tuxpan", code: 783 },
	{ name: "Tuxtepec", code: 287 },
	{ name: "Manzanillo", code: 314 },
	{ name: "Tuxtla Gutiérrez", code: 961 },
	{ name: "Uruapan", code: 452 },
	{ name: "Valle De Bravo", code: 726 },
	{ name: "Villahermosa", code: 993 },
	{ name: "Zacapu", code: 436 },
	{ name: "Zacatecas", code: 492 },
	{ name: "Zamora", code: 351 },
	{ name: "Zihuatanejo", code: 755 },
	{ name: "Zitacuaro", code: 715 },
	{ name: "Zumpango", code: 591 },
	{ name: "Acapulco", code: 744 },
	{ name: "Allende", code: 862 },
	{ name: "Apatzingán", code: 453 },
	{ name: "Atlixco", code: 244 },
	{ name: "Ciudad Altamirano", code: 767 },
	{ name: "Ciudad Cuauhtémoc", code: 625 },
	{ name: "Ciudad Obregón", code: 644 },
	{ name: "Coatzacoalcos", code: 921 },
	{ name: "Culiacán", code: 667 },
	{ name: "Fresnillo", code: 493 },
	{ name: "Guamuchil", code: 673 },
	{ name: "Guasave", code: 687 },
	{ name: "Guerrero Negro", code: 615 },
	{ name: "Huatabampo", code: 647 },
	{ name: "Izúcar de Matamoros", code: 243 },
	{ name: "Los Mochis", code: 668 },
	{ name: "Matehuala", code: 488 },
	{ name: "Monclova", code: 866 },
	{ name: "Nacozari", code: 634 },
	{ name: "Nuevo Casa Grandes", code: 636 },
	{ name: "Oaxaca", code: 951 },
	{ name: "Parral", code: 627 },
	{ name: "San Andrés Tuxtla", code: 294 },
	{ name: "San Luis Río Colorado", code: 653 },
	{ name: "Santiago Ixcuintla", code: 323 },
	{ name: "Tapachula", code: 962 },
	{ name: "Tecate", code: 665 },
	{ name: "Tecomán", code: 313 },
	{ name: "Tepatitlán de Morelos", code: 378 },
	{ name: "Villaflores", code: 965 },
	{ name: "Zinapecuaro", code: 451 },
];
